<template>
  <div class="bp-page__header">
    <div class="bp-page__tabs">
      <div class="bp-page__tabs__list">
        <span :class="{ active: isActiveScreen('missions') }" @click="showScreen('missions')">{{
          $t("missions.title")
        }}</span>
        <span :class="{ active: isActiveScreen('shop') }" @click="showScreen('shop')">{{
          $t("shop.title")
        }}</span>
        <template v-if="isMobile">
          <span :class="{ active: isActiveScreen('stats') }" @click="showScreen('stats')">{{
            $t("header.stats")
          }}</span>
          <span :class="{ active: isActiveScreen('faq') }" @click="openFaqPage()">{{
            $t("header.faq")
          }}</span>
          <i class="icon icon-list"></i>
        </template>
      </div>
    </div>
    <template v-if="isActiveScreen('missions') && isDesktop">
      <Warning :warningText="$t('missions.warning_title')" :isHeaderWarning="true" />
    </template>
    <ShopFavoriteLink v-if="isActiveScreen('shop')" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Cookie from "js-cookie";
import env from "@libs/util/environment";

import Warning from "@/components/Common/Warning";
import ShopFavoriteLink from "@/components/Shop/blocks/ShopFavoriteLink";
import WindowSizeMixin from "@/components/Common/WindowSizeMixin";

export default {
  name: "PageHeader",

  components: {
    Warning,
    ShopFavoriteLink,
  },

  mixins: [WindowSizeMixin],

  computed: {
    ...mapGetters("global", ["getScreen"]),
  },

  methods: {
    showScreen(screen = "missions") {
      this.$store.commit("global/writeCurScreen", screen);
      this.$store.commit("shop/writeShopViewType", "list");
    },
    isActiveScreen(screen) {
      return screen === this.getScreen;
    },
    openFaqPage() {
      const user_language = Cookie.get("cur_language") || "en";
      const faq_pages = {
        ru: "https://wf.mail.ru/node/1008255/",
        en: "https://pc.warface.com/en/node/1222059",
        de: "https://pc.warface.com/de/node/1222077",
        fr: "https://pc.warface.com/fr/node/1222061",
        es: "https://pc.warface.com/es/node/1222069",
        cn: "https://pc.warface.com/cn/node/1222069",
      };

      const faq_url = env.isMailRu() ? faq_pages["ru"] : faq_pages[user_language];

      window.open(faq_url, "_blank");
    },
  },
};
</script>
